import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Business } from '../models/business.model';
import { AdminBusinessComponent } from '../admin-business/admin-business.component';
import { AirportService } from '../../airport/airport.service';
var FlightDeckButtonComponent = /** @class */ (function () {
    function FlightDeckButtonComponent(_editContactDialog, _airportService) {
        this._editContactDialog = _editContactDialog;
        this._airportService = _airportService;
        this.businessChange = new EventEmitter();
    }
    FlightDeckButtonComponent.prototype.ngOnInit = function () {
    };
    FlightDeckButtonComponent.prototype.flightDeckBusinessTools = function () {
        var _this = this;
        var dialogRef = this._editContactDialog.open(AdminBusinessComponent, {
            disableClose: false,
            autoFocus: true,
            width: '50%',
            data: {
                business: this.business
            }
        });
        dialogRef.afterClosed().subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // On close, update the business to incorporate the new changes
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        // On close, update the business to incorporate the new changes
                        _a.business = _b.sent();
                        this.businessChange.emit(this.business);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return FlightDeckButtonComponent;
}());
export { FlightDeckButtonComponent };
